import script from "./ListMobWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListMobWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ListMobWindow.vue?vue&type=style&index=0&id=503d09fa&lang=less"

const __exports__ = script;

export default __exports__